import { Divider } from '@chakra-ui/react';
import { useSnackbar } from '@components/snackbar';
import { CloseIcon } from '@sketchnote/icons';
import cn from 'classnames';
import * as React from 'react';
import { useTimerWidgetStore } from 'src/components/navbar/TimerWidget/useTimerWidgetStore';
import { useBoardStore } from 'src/features/boards';

export const DeleteBoardItem = ({
  onCancel: onClose,
  selectedItems,
}: {
  onCancel: () => void;
  selectedItems: string[];
}) => {
  const [open] = useSnackbar();
  const { handleDeleteSelectedItems } = useBoardStore((s) => ({
    handleDeleteSelectedItems: s.handleDeleteSelectedItems,
  }));
  const { fetchTimers } = useTimerWidgetStore((s) => ({
    fetchTimers: s.fetchTimers,
  }));

  const handleDelete = async (e) => {
    e.preventDefault();
    if (selectedItems.length) {
      const success = await handleDeleteSelectedItems(selectedItems);

      if (success) {
        open({
          text: `The task${selectedItems.length === 1 ? ' has' : 's have'} been deleted`,
          snackType: 'standard',
          position: 'bottom-center',
        });
        fetchTimers();
      }
    }
    onClose();
  };

  const handleClose = (e) => {
    e.preventDefault();
    onClose();
  };

  return (
    <div className="relative">
      <button
        aria-label="Close button"
        onClick={handleClose}
        className={cn({
          'text-gray-500 text-xs absolute top-24 right-24': true,
        })}
      >
        <CloseIcon />
      </button>
      <div className="overflow-y-auto pt-20" style={{ maxHeight: '80vh' }}>
        <label className="text-base pb-16 font-regular px-20">
          Are you sure you want to delete {selectedItems.length} items?
        </label>
        <Divider className="pt-10" />
        <p className="text-sm my-15 px-20">
          This action will permanently delete the selected {selectedItems.length} items. This action
          cannot be undone. Please confirm your selection.
        </p>
        <Divider />
        <section className="flex justify-end my-15 px-20">
          <button
            className="flex py-4 my-auto rounded-sm font-regular items-center px-10 border text-base mr-10"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="flex py-4 my-auto rounded-sm font-regular items-center px-15 text-base bg-red-800 text-white"
            onClick={handleDelete}
          >
            Delete
          </button>
        </section>
      </div>
    </div>
  );
};
